import React from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const UserHighlightsSkeleton = () => {
    return (
        <div className="card container-fluid userList">
            <div className="row">
                <div className="col-3 mt-4 d-flex justify-content-center">
                    <Skeleton style={{marginTop:'1.77em'}} width='4em' height='4em' circle />
                </div>
                <div className="card-body col-6">
                    <h6 className="card-title"> <Skeleton /></h6>
                    <p className="card-text"> <span> <Skeleton /></span>
                        <span
                            className="font-weight-normal"><Skeleton /></span>
                        <span>&nbsp;<small><Skeleton /></small></span>
                    </p>
                </div>
                <div className="col-3 d-flex align-items-center justify-content-center">
                    <Skeleton width='2.5em' height='2em' />
                </div>
            </div>
        </div>
    )
}

export default UserHighlightsSkeleton